module.exports = __webpack_public_path__ + "static/media/circleTexture.21a12d79.png";